import angular from 'angular';

// import 'react/src/index'

angular.lowercase = text => (text || '').toLowerCase(); //necessary to fix errors after "ui.bootstrap" injection

export default angular.module('app', [
  'ui.router',
  "ngImgCrop",
  "ngTagsInput",
  "720kb.tooltips",
  "ngSanitize",
  "moment-picker",
  "angucomplete-alt",
  "ui.bootstrap",
  "react"
]);

